@if (result.registryForm) {
  <h4>{{ result.registryForm.formFull }}</h4>
}
@if (changeText.length > 0) {
  <div>
    <ul>
      @for (change of changeText; track change) {
        <li>{{ change }}</li>
      }
    </ul>
  </div>
}
@if (showResults) {
  @if (result.externalOrderNumber?.number) {
  <div class="flex-container">
    <span class="flex-item-3">{{ 'registrationResultsStatic.externalOrderNumber' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-results-external-order-number-text">{{ result.externalOrderNumber!.number }}</span>
  </div>
  }
  @if (uiConfiguration.showFileNumber) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.fileNumber2' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-results-file-number-text">{{ order.lien?.fileNumber }}</span>
    </div>
  }
  @if (uiConfiguration.showRIN) {
    <div class="flex-container">
      <span class="flex-item-3">{{ 'common.labels.rin' | transloco }}</span>
      <span class="flex-item-4" data-testid="lien-results-rin-text">{{ order.lien?.rin }}</span>
    </div>
  }
  <div class="flex-container">
    <span class="flex-item-3">{{ 'common.labels.registrationNumber2' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-results-registration-number-text">{{ result.registrationNumber }}</span>
  </div>
  <div class="flex-container">
    <span class="flex-item-3">{{ 'common.labels.registrationDate2' | transloco }}</span>
    <span class="flex-item-4" data-testid="lien-results-registration-date-text">{{ result.registrationDate |
    localizedDate: "yyyy-MM-dd" }}</span>
  </div>
  @if (uiConfiguration.showResultingExpiryDate) {
    @if (uiConfiguration.showResultingExpiryDate) {
      <div class="flex-container">
        <span class="flex-item-3">{{ 'common.labels.expiryDate2' | transloco }}</span>
        <span class="flex-item-4" data-testid="lien-results-expiry-date-text">{{ (order.lien?.isInfiniteTerm ?? false) ? "NO EXPIRY DATE" : result.expiryDate | localizedDate: "yyyy-MM-dd" }}</span>
      </div>
    }
  }
}